(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warpaint-commerce-header"]) return;
  try {
    
if (!customElements.get('warpaint-shop-menu')) {
  customElements.define('warpaint-shop-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      if (!details || !summary) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          details.open = false;
          summary.focus();
        }
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) details.open = false;
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) details.open = false;
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('a')) details.open = false;
      }, options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
  });
}

document.addEventListener('shopify:cart:lines-update', async (event) => {
  try {
    await event.promise;
    const endpoint = document.querySelector('.wp-header')?.dataset.cartEndpoint;
    if (!endpoint) return;
    const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('[data-wp-cart-count]').forEach((count) => {
      count.textContent = `(${cart.item_count})`;
    });
  } catch (_) {}
});

  } catch(e) { console.error(e); }
})();
})();
